import React, {useEffect, useRef, useState} from "react";
import {styled} from "@mui/material/styles";
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import {Button} from "@material-ui/core";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Slide from "@mui/material/Slide";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {basicSchema} from "../schemas/Schemas";
import {motion} from "framer-motion";
import LoadingButton from "@mui/lab/LoadingButton";
import TextField from "@mui/material/TextField";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers/DesktopDatePicker";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import RichTextEditor from "../RichTextEditor/RichTextEditor";
import EditorState from "draft-js/lib/EditorState";
import {convertToRaw} from "draft-js";
import draftToHtml from "draftjs-to-html";
import CryptoJS from "crypto-js";
import {dateSchema} from "../schemas/Schemas";
import {
    AccountBalanceWallet,
    Apartment,
    Assignment,
    Payment,
    Warning,
    Send,
    Delete,
    CheckCircle,
    Cancel,
    Info,
    CreditCard,
    PhoneAndroid,
    Lock,
    DeleteOutline,
} from '@mui/icons-material';
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    Checkbox,
    Divider,
    Chip,
    IconButton,
} from '@mui/material';
import {ApiDetails, KEY} from "../../dummyData";
import {
    initializeCardPayment,
    getSavedCards,
    chargesSavedCard,
    deleteSavedCard,
    getCardDeclineMessage,
} from "../../services/cardPaymentService";

// Transition component for dialogs
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Styled tooltip component
const HtmlTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} classes={{popper: className}}/>
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#ffffff",
        color: "rgba(0, 0, 0, 0.87)",
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: "1px solid #dadde9",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        padding: "12px 16px",
        borderRadius: "8px"
    },
}));

export default function FeaturedInfoModern(props) {
    // Decrypt tenant details from localStorage
    let details = CryptoJS.AES.decrypt(
        localStorage.getItem("tenant_details"),
        KEY
    );

    let originalText = details.toString(CryptoJS.enc.Utf8);

    // State variables
    const [detailsSet, setDetailsSet] = useState(false);
    const [backDrop, setBackDrop] = useState(
        <Backdrop
            sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={true}
        >
            <CircularProgress color="inherit"/>
        </Backdrop>
    );

    const [tenantDetails, setTenantDetails] = useState(
        new Map(
            Object.entries({
                tenant_id: "",
                first_name: "",
                last_name: "",
                national_id: "",
                email_address: "",
                phone_number: "",
                house_number: "",
                rent: "",
                bill: "",
                arrears: "",
                account_balance: "",
                amount: "",
                state: "",
                temp_account_balance: "",
                minimum_days_to_vacate: "",
                date_created: "",
                Wallet: "",
                status: "",
                property_name: "",
            })
        )
    );

    const [warningModal, setWarningModal] = useState(false);
    const [paymentModal, setPaymentModal] = useState(false);
    const [vacatingNoticeModal, setVacatingNoticeModal] = useState(false);
    // New state for recall reason modal
    const [recallReasonModal, setRecallReasonModal] = useState(false);
    const [recallReason, setRecallReason] = useState("");

    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [dateToday] = useState(new Date());
    const [dateToVacate, setDateToVacate] = useState(new Date());
    const [tenantLoading, setTenantLoading] = useState(false);
    const [valuesAfterWarning, setValuesAfterWarning] = useState({});
    const [vacatingWarningModalNotice, setVacatingWarningModalNotice] = useState("");

    // Card payment state
    const [paymentMethod, setPaymentMethod] = useState('mpesa'); // 'mpesa' or 'card'
    const [savedCards, setSavedCards] = useState([]);
    const [selectedCardId, setSelectedCardId] = useState(null);
    const [saveNewCard, setSaveNewCard] = useState(true);
    const [cardsLoading, setCardsLoading] = useState(false);
    const [cardPaymentLoading, setCardPaymentLoading] = useState(false);

    // STK Push SSE state
    const [stkWaiting, setStkWaiting] = useState(false);
    const [stkAmount, setStkAmount] = useState(0);
    const [stkElapsed, setStkElapsed] = useState(0);
    const stkAbortRef = useRef(null);

    // Initial values for forms
    const initialPaymentValues = {
        amount: tenantDetails.get("status") === "COMPLETED" ? 0 : tenantDetails.get("Wallet"),
        phone_number: tenantDetails.get("phone_number"),
    };

    const initialValues2 = {
        first_name: tenantDetails.get("first_name"),
        last_name: tenantDetails.get("last_name"),
        phone_number: tenantDetails.get("phone_number"),
        national_id: tenantDetails.get("national_id"),
        unit: tenantDetails.get("house_number"),
        property_name: tenantDetails.get("property_name"),
        landlord_id: tenantDetails.get("landlord_id"),
        tenant_id: tenantDetails.get("tenant_id"),
    };

    useEffect(() => {
        fetchTenantDetails();
    }, []);

    useEffect(() => {
        if (!stkWaiting) { setStkElapsed(0); return; }
        const interval = setInterval(() => setStkElapsed(s => s + 1), 1000);
        return () => clearInterval(interval);
    }, [stkWaiting]);

    const fetchTenantDetails = () => {
        setBackDrop(
            <Backdrop
                sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
                open={true}
                onClick={null}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
        fetch(ApiDetails + "pegasus/visionary/tenant/app/tenantDetails", {
            method: "POST",
            headers: {
                "token": new Map(
                    Object.entries(JSON.parse(originalText))
                ).get("access_token"),
            },
            body: JSON.stringify({
                tenant_id: new Map(
                    Object.entries(JSON.parse(originalText))
                ).get("tenant_id"),
            }),
        })
            .then(async (response) => {
                let data = await response.json();
                if (response.status === 200) {
                    setTenantDetails(new Map(Object.entries(data)));

                    console.log("tenantDetails");
                    console.log(data);

                    setDetailsSet(true);
                    setBackDrop(<></>);
                } else if (response.status === 401) {
                    props.snackBar({
                        text: "Maximum concurrent logins reached",
                        type: "warning",
                    });
                } else if (response.status === 400) {
                    props.snackBar({
                        text: "Invalid Credentials Provided.",
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                props.snackBar({
                    text: "Something Went Wrong. Try Again Later",
                    type: "error",
                });
            });
    };

    const processPayment = async (values) => {
        setTenantLoading(true);
        setStkAmount(values.amount);

        if (values.phone_number.toString().startsWith("0")) {
            values.phone_number = "254" + values.phone_number.toString().substring(1);
        } else if (
            values.phone_number.toString().startsWith("1") ||
            values.phone_number.toString().startsWith("7")
        ) {
            values.phone_number = "254" + values.phone_number.toString();
        }

        let body = {
            tenant_id: tenantDetails.get("tenant_id"),
            phone_number: values.phone_number,
            amount: values.amount,
        };

        fetch(ApiDetails + "pegasus/visionary/mpesa/StkPush", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": new Map(
                    Object.entries(JSON.parse(originalText))
                ).get("access_token"),
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                let data = await response.json();

                // Handle authentication/authorization issues first
                if (response.status === 403) {
                    // Check if it's a session expiry or duplicate transaction
                    if (data.Message && data.Message.includes("ongoing transaction")) {
                        setTenantLoading(false);
                        props.snackBar({
                            text: data.Message,
                            type: "warning",
                        });
                    } else {
                        // Session expired - redirect to login
                        localStorage.clear();
                        window.location.href = "/";
                        return;
                    }
                }
                // Success - STK Push initiated successfully
                else if (response.status === 200) {
                    setTenantLoading(false);
                    const transactionRef = data.transaction_ref || data.CheckoutRequestID || data.conversation_id;
                    if (data.success && transactionRef) {
                        setStkWaiting(true);
                        watchPaymentStatus(transactionRef);
                        return; // keep dialog open — SSE screen takes over
                    } else {
                        props.snackBar({
                            text: "Kindly wait for M-Pesa prompt on your phone",
                            type: "success",
                        });
                        handleClose();
                    }
                }
                // Bad Request - M-Pesa validation errors
                else if (response.status === 400) {
                    setTenantLoading(false);
                    let errorMessage = "Payment request failed";

                    // Handle both error formats
                    if (data.userMessage) {
                        // Backend provided user-friendly message
                        errorMessage = data.userMessage;
                    } else if (data.errorMessage) {
                        // New error format (errorCode/errorMessage)
                        errorMessage = data.errorMessage;
                    } else if (data.ResponseDescription) {
                        // Original format (ResponseCode/ResponseDescription)
                        const responseDesc = data.ResponseDescription.toLowerCase();
                        if (responseDesc.includes("insufficient funds")) {
                            errorMessage = "💳 Insufficient funds in your M-Pesa account";
                        } else if (responseDesc.includes("minimum transaction")) {
                            errorMessage = "⬇️ Amount is below minimum transaction limit";
                        } else if (responseDesc.includes("maximum transaction")) {
                            errorMessage = "⬆️ Amount exceeds maximum transaction limit";
                        } else if (responseDesc.includes("daily transfer limit")) {
                            errorMessage = "📊 Daily transfer limit exceeded";
                        } else if (responseDesc.includes("duplicate")) {
                            errorMessage = "🔄 Duplicate transaction detected";
                        } else if (responseDesc.includes("invalid")) {
                            errorMessage = "❌ Invalid account or phone number";
                        } else {
                            errorMessage = data.ResponseDescription;
                        }
                    } else if (data.Error) {
                        errorMessage = data.Error;
                    }

                    props.snackBar({
                        text: errorMessage,
                        type: "error",
                    });
                }
                // Unauthorized - Authentication/authorization issues with M-Pesa
                else if (response.status === 401) {
                    setTenantLoading(false);
                    let errorMessage = "🔐 Authentication error with payment service";

                    // Handle specific credential errors
                    if (data.errorCode === "500.001.1001" || data.errorMessage?.toLowerCase().includes("wrong credentials")) {
                        errorMessage = "🔐 Invalid M-Pesa credentials. Please contact system administrator.";
                    } else if (data.userMessage) {
                        errorMessage = data.userMessage;
                    } else if (data.errorMessage) {
                        errorMessage = data.errorMessage;
                    }

                    props.snackBar({
                        text: errorMessage,
                        type: "error",
                    });
                }
                // Request Timeout - User cancelled or timeout
                else if (response.status === 408) {
                    setTenantLoading(false);
                    props.snackBar({
                        text: "Payment request timed out or was cancelled",
                        type: "warning",
                    });
                }
                // Internal Server Error
                else if (response.status === 500) {
                    setTenantLoading(false);
                    props.snackBar({
                        text: "Server error occurred. Please try again later.",
                        type: "error",
                    });
                }
                // Bad Gateway - M-Pesa service issues
                else if (response.status === 502) {
                    setTenantLoading(false);
                    props.snackBar({
                        text: "M-Pesa service is currently unavailable. Please try again later.",
                        type: "error",
                    });
                }
                // Handle any other status codes
                else {
                    setTenantLoading(false);
                    const errorMessage = data.Error || data.Message || "Payment request failed";
                    props.snackBar({
                        text: errorMessage,
                        type: "error",
                    });
                }

                handleClose();
            })
            .catch((err) => {
                console.error("STK Push Error:", err);
                setTenantLoading(false);
                setStkWaiting(false);

                // Handle network errors
                if (err.name === 'TypeError' && err.message.includes('fetch')) {
                    props.snackBar({
                        text: "Network error. Please check your connection and try again.",
                        type: "error",
                    });
                } else {
                    props.snackBar({
                        text: "Payment request failed. Please try again.",
                        type: "error",
                    });
                }

                handleClose();
            });

        // fetchTenantDetails();
    };

    const watchPaymentStatus = (transactionRef) => {
        const token = new Map(Object.entries(JSON.parse(originalText))).get("access_token");
        const controller = new AbortController();
        stkAbortRef.current = controller;

        fetch(ApiDetails + "pegasus/visionary/mpesa/StkPush/status", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": token,
            },
            body: JSON.stringify({ transaction_ref: transactionRef }),
            signal: controller.signal,
        }).then(async (response) => {
            if (!response.body) {
                setStkWaiting(false);
                props.snackBar({ text: "Check your phone for M-Pesa prompt.", type: "success" });
                handleClose();
                return;
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n');
                buffer = lines.pop();

                let eventName = '';
                let dataStr = '';

                for (const line of lines) {
                    if (line.startsWith('event: ')) {
                        eventName = line.slice(7).trim();
                    } else if (line.startsWith('data: ')) {
                        dataStr = line.slice(6).trim();
                    } else if (line === '') {
                        if (eventName && dataStr) {
                            try {
                                const eventData = JSON.parse(dataStr);
                                if (eventName === 'payment_completed') {
                                    setStkWaiting(false);
                                    props.snackBar({ text: "Payment confirmed! Your account has been updated.", type: "success" });
                                    handleClose();
                                    fetchTenantDetails();
                                    return;
                                } else if (eventName === 'payment_failed') {
                                    setStkWaiting(false);
                                    props.snackBar({ text: eventData.message || "Payment failed or was cancelled.", type: "error" });
                                    return;
                                } else if (eventName === 'payment_timeout') {
                                    setStkWaiting(false);
                                    props.snackBar({ text: eventData.message || "Payment timed out. Please try again.", type: "warning" });
                                    return;
                                }
                            } catch (e) {
                                console.error('Error parsing SSE data:', e);
                            }
                        }
                        eventName = '';
                        dataStr = '';
                    }
                }
            }
        }).catch((err) => {
            if (err.name === 'AbortError') return; // user cancelled, nothing to do
            console.error('SSE connection error:', err);
            setStkWaiting(false);
            props.snackBar({ text: "Check your phone for M-Pesa prompt.", type: "success" });
            handleClose();
        });
    };

    // Fetch saved cards when payment modal opens
    const fetchSavedCards = async () => {
        setCardsLoading(true);
        try {
            const cards = await getSavedCards({
                tenantId: tenantDetails.get("tenant_id"),
                token: new Map(Object.entries(JSON.parse(originalText))).get("access_token"),
            });
            setSavedCards(cards);
            // Auto-select default card if available
            const defaultCard = cards.find(c => c.is_default);
            if (defaultCard) {
                setSelectedCardId(defaultCard.id);
            }
        } catch (error) {
            console.error("Error fetching saved cards:", error);
            if (error.statusCode === 403) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }
        } finally {
            setCardsLoading(false);
        }
    };

    // Process card payment (new card)
    const processNewCardPayment = async (amount) => {
        setCardPaymentLoading(true);
        try {
            const result = await initializeCardPayment({
                tenantId: tenantDetails.get("tenant_id"),
                propertyId: tenantDetails.get("property_id"),
                amount: amount,
                email: tenantDetails.get("email_address"),
                saveCard: saveNewCard,
                token: new Map(Object.entries(JSON.parse(originalText))).get("access_token"),
            });

            if (result.success && result.authorization_url) {
                // Redirect to Paystack checkout
                window.location.href = result.authorization_url;
            } else {
                props.snackBar({
                    text: result.message || "Failed to initialize payment",
                    type: "error",
                });
            }
        } catch (error) {
            console.error("Card payment error:", error);
            if (error.statusCode === 403) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }
            props.snackBar({
                text: error.message || "Failed to process card payment",
                type: "error",
            });
        } finally {
            setCardPaymentLoading(false);
        }
    };

    // Process saved card payment
    const processSavedCardPayment = async (amount) => {
        if (!selectedCardId) {
            props.snackBar({
                text: "Please select a card",
                type: "error",
            });
            return;
        }

        setCardPaymentLoading(true);
        try {
            const currentDate = new Date();
            const description = `Rent Payment - ${currentDate.toLocaleString('en-US', { month: 'long' })} ${currentDate.getFullYear()} - Unit ${tenantDetails.get("house_number")}`;

            const result = await chargesSavedCard({
                cardTokenId: selectedCardId,
                tenantId: tenantDetails.get("tenant_id"),
                propertyId: tenantDetails.get("property_id"),
                amount: amount,
                description: description,
                token: new Map(Object.entries(JSON.parse(originalText))).get("access_token"),
            });

            if (result.success) {
                props.snackBar({
                    text: `Payment of KES ${amount.toLocaleString()} successful!`,
                    type: "success",
                });
                handleClose();
                // Refresh tenant details to update balance
                fetchTenantDetails();
            } else {
                props.snackBar({
                    text: getCardDeclineMessage(result.message),
                    type: "error",
                });
            }
        } catch (error) {
            console.error("Saved card payment error:", error);
            if (error.statusCode === 403) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }
            props.snackBar({
                text: getCardDeclineMessage(error.message),
                type: "error",
            });
        } finally {
            setCardPaymentLoading(false);
        }
    };

    // Delete a saved card
    const handleDeleteCard = async (cardId) => {
        try {
            const result = await deleteSavedCard({
                cardTokenId: cardId,
                tenantId: tenantDetails.get("tenant_id"),
                token: new Map(Object.entries(JSON.parse(originalText))).get("access_token"),
            });

            if (result.success) {
                props.snackBar({
                    text: "Card deleted successfully",
                    type: "success",
                });
                // Refresh saved cards
                fetchSavedCards();
                // Clear selection if deleted card was selected
                if (selectedCardId === cardId) {
                    setSelectedCardId(null);
                }
            } else {
                props.snackBar({
                    text: result.message || "Failed to delete card",
                    type: "error",
                });
            }
        } catch (error) {
            console.error("Delete card error:", error);
            props.snackBar({
                text: error.message || "Failed to delete card",
                type: "error",
            });
        }
    };

    // Handle card payment form submission
    const handleCardPayment = (values) => {
        const amount = parseFloat(values.amount);
        if (isNaN(amount) || amount <= 0) {
            props.snackBar({
                text: "Please enter a valid amount",
                type: "error",
            });
            return;
        }

        if (selectedCardId && paymentMethod === 'card') {
            // Use saved card
            processSavedCardPayment(amount);
        } else {
            // Use new card
            processNewCardPayment(amount);
        }
    };

    // Helper function to convert month number to name
    function toMonthName(monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber);
        return date.toLocaleString("en-US", {month: "long"});
    }

    // Checklist validation function
    const getVacatingChecklist = () => {
        const checklist = [];
        const today = new Date();
        const vacateDate = new Date(dateToVacate);
        const dateJoined = new Date(tenantDetails.get("date_created").toString());
        const minimumMonths = tenantDetails.get("minimum_days_to_vacate");

        // Calculate months difference
        const monthsDifference =
            vacateDate.getFullYear() * 12 + vacateDate.getMonth() -
            (dateJoined.getFullYear() * 12 + dateJoined.getMonth());

        // Calculate days until vacating
        const daysUntilVacating = Math.ceil((vacateDate - today) / (1000 * 60 * 60 * 24));

        // 1. Notice timing (before 5th of month)
        checklist.push({
            id: 'notice_timing',
            title: 'Notice Given Before 5th of Month',
            description: 'Notice should be given before the 5th to avoid deposit forfeiture risk',
            status: today.getDate() <= 5 ? 'passed' : 'warning',
            risk: today.getDate() > 5 ? 'May risk deposit forfeiture' : null
        });

        // 2. Minimum stay period
        checklist.push({
            id: 'minimum_stay',
            title: `Minimum Stay Period (${minimumMonths} months)`,
            description: `You must stay for at least ${minimumMonths} months to qualify for deposit refund`,
            status: monthsDifference >= minimumMonths ? 'passed' : 'warning',
            risk: monthsDifference < minimumMonths ? 'Deposit will not be refunded' : null
        });

        // 3. Outstanding bills
        const hasOutstandingBills = tenantDetails.get("status") !== "COMPLETED";
        checklist.push({
            id: 'outstanding_bills',
            title: 'Clear All Outstanding Bills',
            description: 'All rent and utility bills must be paid before vacating',
            status: !hasOutstandingBills ? 'passed' : 'failed',
            risk: hasOutstandingBills ? 'Must clear all bills before vacating' : null
        });

        // 4. One month notice period
        checklist.push({
            id: 'notice_period',
            title: 'One Month Notice Period',
            description: 'Give at least 30 days notice before vacating',
            status: daysUntilVacating >= 30 ? 'passed' : 'warning',
            risk: daysUntilVacating < 30 ? 'Short notice may affect deposit refund' : null
        });

        // 5. End of month vacating
        const vacateDay = vacateDate.getDate();
        checklist.push({
            id: 'end_of_month',
            title: 'Vacate at End of Month',
            description: 'Vacating should occur between 28th-31st of the month',
            status: vacateDay >= 28 ? 'passed' : 'warning',
            risk: vacateDay < 28 ? 'May incur additional charges for partial month' : null
        });

        // 6. Property condition (informational)
        checklist.push({
            id: 'property_condition',
            title: 'Property in Good Condition',
            description: 'Ensure property has no damages beyond normal wear and tear',
            status: 'info',
            risk: null
        });

        // 7. Key return (informational)
        checklist.push({
            id: 'key_return',
            title: 'Return All Keys & Access Cards',
            description: 'All keys and access cards must be returned on vacating day',
            status: 'info',
            risk: null
        });

        // 8. Forwarding address (informational)
        checklist.push({
            id: 'forwarding_address',
            title: 'Provide Forwarding Address',
            description: 'Provide valid address for deposit refund communication',
            status: 'info',
            risk: null
        });

        return checklist;
    };

    // Send vacating notice function with API call
    const sendVacatingNotice = (values) => {
        setTenantLoading(true);

        // Get minimum months before vacating
        let minimumMonthsBeforeVacating = tenantDetails.get("minimum_days_to_vacate");

        // Calculate difference in months
        let dateJoined = new Date(tenantDetails.get("date_created").toString());
        let vacatingDate = new Date(dateToVacate.toJSON());
        let difference =
            vacatingDate.getFullYear() * 12 +
            vacatingDate.getMonth() -
            (dateJoined.getFullYear() * 12 + dateJoined.getMonth());

        // Prepare values for API
        const apiValues = {
            first_name: tenantDetails.get("first_name"),
            last_name: tenantDetails.get("last_name"),
            phone_number: tenantDetails.get("phone_number"),
            national_id: tenantDetails.get("national_id"),
            unit: tenantDetails.get("house_number"),
            property_name: tenantDetails.get("property_name"),
            landlord_id: tenantDetails.get("landlord_id"),
            tenant_id: tenantDetails.get("tenant_id"),
            date_to_vacate_house:
                toMonthName(new Date(dateToVacate.toJSON()).getMonth()) +
                " " +
                new Date(dateToVacate.toJSON()).getDate() +
                ", " +
                new Date(dateToVacate.toJSON()).getFullYear(),
            date_notice_given: new Date(),
            reasons_for_vacating: JSON.stringify(
                convertToRaw(editorState.getCurrentContent())
            ),
            landlord_notice: true,
        };

        // Validate vacating date
        if (difference < minimumMonthsBeforeVacating) {
            setValuesAfterWarning(apiValues);
            handleClose();
            setVacatingWarningModalNotice(
                "Please note that you need to have occupied the premises for at least " +
                minimumMonthsBeforeVacating +
                " months to qualify for refund of deposit.\nIf you " +
                "proceed, your deposit shall not be refunded"
            );
            setWarningModal(true);
            setTenantLoading(false);
            return;
        } else if (
            new Date(dateToVacate.toJSON()).getFullYear() < dateToday.getFullYear()
        ) {
            props.snackBar({
                text: "Invalid date to vacate.",
                type: "error",
            });
            setTenantLoading(false);
            return;
        } else if (
            new Date(dateToVacate.toJSON()).getFullYear() === dateToday.getFullYear() &&
            new Date(dateToVacate.toJSON()).getMonth() < dateToday.getMonth()
        ) {
            props.snackBar({
                text: "Invalid date to vacate.",
                type: "error",
            });
            setTenantLoading(false);
            return;
        } else if (
            new Date(dateToVacate.toJSON()).getDate() < 28 &&
            new Date(dateToVacate.toJSON()).getMonth() === dateToday.getMonth()
        ) {
            setValuesAfterWarning(apiValues);
            handleClose();
            setVacatingWarningModalNotice(
                "Notice to vacate are given one month in advance.\nIf you " +
                "proceed, you risk not being refunded your deposit"
            );
            setWarningModal(true);
            setTenantLoading(false);
            return;
        } else if (
            dateToday.getDate() >= 3 &&
            new Date(dateToVacate.toJSON()).getMonth() === dateToday.getMonth()
        ) {
            setValuesAfterWarning(apiValues);
            handleClose();
            setVacatingWarningModalNotice(
                "Notice to vacate are given before the 3rd of the month.\nIf you " +
                "proceed, you risk not being refunded your deposit"
            );
            setWarningModal(true);
            setTenantLoading(false);
            return;
        } else if (new Date(dateToVacate.toJSON()).getDate() < 28) {
            props.snackBar({
                text: "You can only vacate property at the end of the month",
                type: "error",
            });
            setTenantLoading(false);
            return;
        } else {
            // Make API call to submit notice
            fetch(ApiDetails + "pegasus/visionary/tenant/app/AddNotice", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": new Map(
                        Object.entries(JSON.parse(originalText))
                    ).get("access_token"),
                },
                body: JSON.stringify(apiValues),
            })
                .then(async (response) => {
                    if (response.status === 200) {
                        props.snackBar({
                            text: "Notice uploaded successfully.",
                            type: "success",
                        });
                        setTenantLoading(false);
                        handleClose();
                        fetchTenantDetails(); // Refresh tenant details
                    } else {
                        setTenantLoading(false);
                        handleClose();
                        props.snackBar({
                            text: "Something went wrong. Kindly try again later.",
                            type: "error",
                        });
                    }
                })
                .catch((err) => {
                    setTenantLoading(false);
                    handleClose();
                    console.log(err);
                    props.snackBar({
                        text: "Something went wrong. Kindly try again later.",
                        type: "error",
                    });
                });
        }
    };

    // Send vacating notice after warning with API call
    const sendVacatingNoticeAfterWarning = () => {
        setTenantLoading(true);

        fetch(ApiDetails + "pegasus/visionary/tenant/app/AddNotice", {
            method: "POST",
            headers: {
                "token": new Map(
                    Object.entries(JSON.parse(originalText))
                ).get("access_token"),
                "Content-Type": "application/json",
            },
            body: JSON.stringify(valuesAfterWarning),
        })
            .then(async (response) => {
                if (response.status === 200) {
                    props.snackBar({
                        text: "Notice uploaded successfully.",
                        type: "success",
                    });
                    setTenantLoading(false);
                    handleClose();
                    fetchTenantDetails(); // Refresh tenant details
                } else {
                    setTenantLoading(false);
                    handleClose();
                    props.snackBar({
                        text: "Something went wrong. Kindly try again later.",
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                setTenantLoading(false);
                handleClose();
                console.log(err);
                props.snackBar({
                    text: "Something went wrong. Kindly try again later.",
                    type: "error",
                });
            });
    };

    // Updated Delete/Recall notice function with reason
    const deleteNotice = (id, reason) => {
        setTenantLoading(true);

        fetch(
            ApiDetails +
            "pegasus/visionary/authorization/admin/delete/specific/tenant/notices",
            {
                method: "POST",
                headers: {
                    "token": new Map(
                        Object.entries(JSON.parse(originalText))
                    ).get("access_token"),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: id,
                    tenant_id: tenantDetails.get("tenant_id"),
                    recall_reason: reason
                }),
            }
        )
            .then(async (response) => {
                let data = await response.json();
                if (response.status === 200) {
                    props.snackBar({
                        text: "Notice recalled successfully.",
                        type: "success",
                    });
                    setTenantLoading(false);
                    handleClose();
                    fetchTenantDetails(); // Refresh tenant details
                } else {
                    setTenantLoading(false);
                    props.snackBar({
                        text: "Something went wrong. Kindly try again later.",
                        type: "error",
                    });
                }
            })
            .catch((error) => {
                console.error("Error deleting notice:", error);
                setTenantLoading(false);
                props.snackBar({
                    text: "Something went wrong. Kindly try again later.",
                    type: "error",
                });
            });
    };

    // Handle recall notice button click
    const handleRecallNoticeClick = () => {
        setRecallReasonModal(true);
    };

    // Handle recall reason submission
    const handleRecallReasonSubmit = () => {
        if (!recallReason.trim()) {
            props.snackBar({
                text: "Please provide a reason for recalling the notice.",
                type: "error",
            });
            return;
        }

        const noticeId = new Map(Object.entries(tenantDetails.get("notice") || {})).get("id");
        if (noticeId) {
            deleteNotice(noticeId, recallReason);
        }
    };

    // Dialog close handler
    const handleClose = () => {
        setPaymentModal(false);
        setVacatingNoticeModal(false);
        setWarningModal(false);
        setRecallReasonModal(false);
        setRecallReason("");
        // Reset card payment state
        setPaymentMethod('mpesa');
        setSelectedCardId(null);
        setSaveNewCard(true);
        setStkWaiting(false);
    };

    // Open payment modal and fetch saved cards
    const openPaymentModal = () => {
        setPaymentModal(true);
        fetchSavedCards();
    };

    // Format amount based on status
    const getFormattedWalletBalance = () => {
        if (tenantDetails.get("status") !== "COMPLETED") {
            return parseInt("0").toLocaleString("en-US", {
                style: "currency",
                currency: "KES",
            });
        } else {
            return parseInt(
                tenantDetails.get("Wallet")?.toString().replace(",", "") || "0"
            ).toLocaleString("en-US", {
                style: "currency",
                currency: "KES",
            });
        }
    };

    return (
        <>
            {backDrop}

            {/* Warning Dialog */}
            <Dialog
                open={warningModal}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogTitle
                    style={{
                        color: "#3A5A78",
                        borderBottom: '1px solid #eaeaea',
                        padding: '20px 24px',
                        fontSize: '18px',
                        fontWeight: 600
                    }}
                >
                    Warning
                </DialogTitle>
                <DialogContent sx={{padding: '24px'}}>
                    <DialogContentText id="alert-dialog-slide-description">
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: "16px"
                            }}
                        >
                            <Warning
                                style={{
                                    fontSize: 40,
                                    color: "#F59E0B",
                                }}
                            />
                            <div style={{fontSize: '15px', lineHeight: '1.5'}}>
                                {vacatingWarningModalNotice}
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{padding: '16px 24px'}}>
                    <LoadingButton
                        onClick={() => {
                            handleClose();
                            sendVacatingNoticeAfterWarning();
                        }}
                        loading={tenantLoading}
                        style={{
                            color: "#10B981",
                            fontWeight: 500,
                            textTransform: 'none'
                        }}
                    >
                        Proceed
                    </LoadingButton>
                    <Button
                        onClick={handleClose}
                        style={{
                            color: "#EF4444",
                            fontWeight: 500,
                            textTransform: 'none'
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* NEW: Recall Reason Dialog */}
            <Dialog
                open={recallReasonModal}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="recall-reason-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                        minWidth: '400px'
                    }
                }}
            >
                <DialogTitle
                    style={{
                        color: "#3A5A78",
                        borderBottom: '1px solid #eaeaea',
                        padding: '20px 24px',
                        fontSize: '18px',
                        fontWeight: 600,
                        textAlign: 'center'
                    }}
                >
                    📝 Recall Vacating Notice
                </DialogTitle>
                <DialogContent sx={{padding: '24px'}}>
                    <DialogContentText sx={{marginBottom: '16px', color: '#6B7280'}}>
                        Please provide a reason for recalling your vacating notice. This will be recorded for management review.
                    </DialogContentText>

                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        rows={4}
                        label="Reason for Recall"
                        placeholder="e.g., Change of plans, found alternative accommodation, family circumstances..."
                        value={recallReason}
                        onChange={(e) => setRecallReason(e.target.value)}
                        variant="outlined"
                        InputLabelProps={{
                            style: { color: '#3A5A78' }
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                            }
                        }}
                    />

                    <div style={{
                        marginTop: '16px',
                        padding: '12px',
                        backgroundColor: '#FEF3C7',
                        borderRadius: '8px',
                        border: '1px solid #F59E0B',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <Info style={{ color: '#D97706', fontSize: '20px' }} />
                        <span style={{ fontSize: '14px', color: '#92400E' }}>
                            Note: Recalling a notice may affect your deposit refund eligibility depending on timing and circumstances.
                        </span>
                    </div>
                </DialogContent>

                <DialogActions sx={{padding: '16px 24px'}}>
                    <Button
                        onClick={handleClose}
                        style={{
                            color: "#6B7280",
                            fontWeight: 500,
                            textTransform: 'none'
                        }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        onClick={handleRecallReasonSubmit}
                        loading={tenantLoading}
                        startIcon={<Delete />}
                        loadingPosition="start"
                        style={{
                            color: "white",
                            backgroundColor: "#EF4444",
                            textTransform: 'none',
                            padding: '8px 16px',
                            borderRadius: '6px'
                        }}
                    >
                        Recall Notice
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            {detailsSet && (
                <>
                    {/* Payment Dialog */}
                    <Dialog
                        open={paymentModal}
                        TransitionComponent={Transition}
                        keepMounted
                        maxWidth="sm"
                        fullWidth
                        aria-describedby="payment-dialog-description"
                        PaperProps={{
                            style: {
                                borderRadius: '12px',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                            }
                        }}
                    >
                        <DialogTitle
                            style={{
                                color: "#3A5A78",
                                borderBottom: '1px solid #eaeaea',
                                padding: '20px 24px',
                                fontSize: '18px',
                                fontWeight: 600
                            }}
                        >
                            Make Payment
                        </DialogTitle>
                        <DialogContent sx={{padding: '24px'}}>
                            <DialogContentText id="payment-dialog-description" component="div">
                                {tenantLoading && paymentMethod === 'mpesa' && !stkWaiting ? (
                                    /* ── Phase 1: STK push request in-flight ── */
                                    <div style={{ textAlign: 'center', padding: '32px 16px' }}>
                                        <style>{`
                                            @keyframes stkSendPulse {
                                                0%,100% { transform: scale(1); opacity: 0.85; }
                                                50% { transform: scale(1.12); opacity: 1; }
                                            }
                                            @keyframes stkDotBlink {
                                                0%,80%,100% { opacity: 0.2; transform: scale(0.8); }
                                                40% { opacity: 1; transform: scale(1); }
                                            }
                                        `}</style>

                                        <div style={{
                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                            width: 76, height: 76, borderRadius: '50%',
                                            backgroundColor: '#ECFDF5',
                                            animation: 'stkSendPulse 1.2s ease-in-out infinite',
                                            marginBottom: '20px',
                                        }}>
                                            <PhoneAndroid style={{ fontSize: 38, color: '#10B981' }} />
                                        </div>

                                        <div style={{ fontSize: '18px', fontWeight: 700, color: '#111827', marginBottom: '8px' }}>
                                            Contacting M-Pesa
                                        </div>
                                        <div style={{ fontSize: '14px', color: '#6B7280', marginBottom: '6px' }}>
                                            Sending payment request to your phone
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#9CA3AF', marginBottom: '28px' }}>
                                            KES {Number(stkAmount).toLocaleString()} · This takes a few seconds…
                                        </div>

                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '7px' }}>
                                            {[0, 1, 2].map(i => (
                                                <div key={i} style={{
                                                    width: 9, height: 9, borderRadius: '50%',
                                                    backgroundColor: '#10B981',
                                                    animation: 'stkDotBlink 1.4s ease-in-out infinite',
                                                    animationDelay: `${i * 0.18}s`,
                                                }} />
                                            ))}
                                        </div>
                                    </div>
                                ) : stkWaiting ? (() => {
                                    const countdown = Math.max(0, 60 - stkElapsed);
                                    const cMins = Math.floor(countdown / 60);
                                    const cSecs = countdown % 60;
                                    const countdownStr = `${cMins}:${cSecs.toString().padStart(2, '0')}`;
                                    const isExpired = countdown === 0;
                                    return (
                                    <div>
                                        <style>{`
                                            @keyframes stkPhoneRing {
                                                0%,55%,100% { transform: rotate(0deg) scale(1); }
                                                10% { transform: rotate(-14deg) scale(1.08); }
                                                20% { transform: rotate(14deg) scale(1.08); }
                                                30% { transform: rotate(-10deg) scale(1.06); }
                                                40% { transform: rotate(8deg) scale(1.04); }
                                                50% { transform: rotate(0deg) scale(1); }
                                            }
                                            @keyframes stkPulseRing {
                                                0% { box-shadow: 0 0 0 0 rgba(16,185,129,0.45); }
                                                70% { box-shadow: 0 0 0 22px rgba(16,185,129,0); }
                                                100% { box-shadow: 0 0 0 0 rgba(16,185,129,0); }
                                            }
                                        `}</style>

                                        {/* Phone animation */}
                                        <div style={{ textAlign: 'center', padding: '20px 0 12px' }}>
                                            <div style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 76,
                                                height: 76,
                                                borderRadius: '50%',
                                                backgroundColor: '#D1FAE5',
                                                animation: 'stkPulseRing 2s ease-out infinite',
                                            }}>
                                                <PhoneAndroid style={{
                                                    fontSize: 38,
                                                    color: '#10B981',
                                                    animation: 'stkPhoneRing 2.4s ease-in-out infinite',
                                                }} />
                                            </div>
                                        </div>

                                        {/* Amount */}
                                        <div style={{ textAlign: 'center', marginBottom: '12px' }}>
                                            <div style={{ fontSize: '12px', color: '#9CA3AF', letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: '2px' }}>
                                                Payment amount
                                            </div>
                                            <div style={{ fontSize: '30px', fontWeight: 700, color: '#111827', lineHeight: 1 }}>
                                                KES {Number(stkAmount).toLocaleString()}
                                            </div>
                                        </div>

                                        {/* Countdown badge */}
                                        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                            <span style={{
                                                display: 'inline-block',
                                                padding: '4px 14px',
                                                borderRadius: '20px',
                                                fontSize: '12px',
                                                fontWeight: 600,
                                                backgroundColor: isExpired ? '#FEF2F2' : countdown > 20 ? '#ECFDF5' : '#FFFBEB',
                                                border: `1px solid ${isExpired ? '#FECACA' : countdown > 20 ? '#6EE7B7' : '#FCD34D'}`,
                                                color: isExpired ? '#B91C1C' : countdown > 20 ? '#065F46' : '#92400E',
                                            }}>
                                                {isExpired
                                                    ? 'Prompt may have expired — still checking...'
                                                    : `M-Pesa prompt expires in ${countdownStr}`}
                                            </span>
                                        </div>

                                        {/* Steps */}
                                        <div style={{ padding: '0 4px', marginBottom: '16px' }}>
                                            {/* Step 1 — done */}
                                            <div style={{
                                                display: 'flex', alignItems: 'center', gap: '12px',
                                                padding: '10px 14px', borderRadius: '10px',
                                                backgroundColor: '#F0FDF4', marginBottom: '8px',
                                            }}>
                                                <div style={{
                                                    width: 28, height: 28, borderRadius: '50%',
                                                    backgroundColor: '#10B981', flexShrink: 0,
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                }}>
                                                    <span style={{ color: '#fff', fontSize: '13px', fontWeight: 700 }}>✓</span>
                                                </div>
                                                <div>
                                                    <div style={{ fontSize: '13px', fontWeight: 600, color: '#065F46' }}>STK Push sent to your phone</div>
                                                    <div style={{ fontSize: '11px', color: '#34D399', marginTop: '1px' }}>You should receive a prompt on your phone shortly</div>
                                                </div>
                                            </div>

                                            {/* Step 2 — active */}
                                            <div style={{
                                                display: 'flex', alignItems: 'center', gap: '12px',
                                                padding: '10px 14px', borderRadius: '10px',
                                                backgroundColor: '#EFF6FF', border: '1.5px solid #BFDBFE',
                                                marginBottom: '8px',
                                            }}>
                                                <div style={{ position: 'relative', width: 28, height: 28, flexShrink: 0 }}>
                                                    <CircularProgress size={28} thickness={4} sx={{ color: '#3B82F6' }} />
                                                </div>
                                                <div>
                                                    <div style={{ fontSize: '13px', fontWeight: 600, color: '#1D4ED8' }}>Waiting for your M-Pesa PIN</div>
                                                    <div style={{ fontSize: '11px', color: '#93C5FD', marginTop: '1px' }}>Open the M-Pesa prompt and enter your PIN to pay</div>
                                                </div>
                                            </div>

                                            {/* Step 3 — pending */}
                                            <div style={{
                                                display: 'flex', alignItems: 'center', gap: '12px',
                                                padding: '10px 14px', borderRadius: '10px',
                                                backgroundColor: '#F9FAFB',
                                            }}>
                                                <div style={{
                                                    width: 28, height: 28, borderRadius: '50%',
                                                    backgroundColor: '#E5E7EB', flexShrink: 0,
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                }}>
                                                    <span style={{ color: '#9CA3AF', fontSize: '13px', fontWeight: 700 }}>3</span>
                                                </div>
                                                <div>
                                                    <div style={{ fontSize: '13px', fontWeight: 600, color: '#6B7280' }}>Payment confirmed</div>
                                                    <div style={{ fontSize: '11px', color: '#D1D5DB', marginTop: '1px' }}>Your rent balance will be updated instantly</div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Go back link */}
                                        <div style={{ textAlign: 'center', paddingBottom: '4px' }}>
                                            <button
                                                onClick={() => {
                                                    stkAbortRef.current?.abort();
                                                    setStkWaiting(false);
                                                }}
                                                style={{
                                                    background: 'none', border: 'none', cursor: 'pointer',
                                                    color: '#6B7280', fontSize: '12px',
                                                    textDecoration: 'underline', padding: '4px 8px',
                                                }}
                                            >
                                                Didn't receive the prompt? Go back and retry
                                            </button>
                                        </div>
                                    </div>
                                    );
                                })() : (
                                <Formik
                                    initialValues={initialPaymentValues}
                                    validationSchema={basicSchema}
                                    onSubmit={(values) => {
                                        if (paymentMethod === 'mpesa') {
                                            processPayment(values);
                                        } else {
                                            handleCardPayment(values);
                                        }
                                    }}
                                >
                                    {(formikProps) => (
                                        <Form noValidate>
                                            {/* Amount Field - Common for both methods */}
                                            <Field
                                                as={TextField}
                                                name="amount"
                                                label="Amount (KES)"
                                                type="number"
                                                required
                                                variant="outlined"
                                                error={formikProps.errors.amount && formikProps.touched.amount}
                                                helperText={
                                                    <ErrorMessage className="error" name="amount"/>
                                                }
                                                style={{marginTop: "8px", width: "100%"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />

                                            <Divider sx={{ my: 3 }} />

                                            {/* Payment Method Selection */}
                                            <FormControl component="fieldset" sx={{ width: '100%' }}>
                                                <FormLabel
                                                    component="legend"
                                                    sx={{
                                                        color: '#3A5A78',
                                                        fontWeight: 600,
                                                        marginBottom: '12px',
                                                        '&.Mui-focused': { color: '#3A5A78' }
                                                    }}
                                                >
                                                    Payment Method
                                                </FormLabel>
                                                <RadioGroup
                                                    value={paymentMethod}
                                                    onChange={(e) => {
                                                        setPaymentMethod(e.target.value);
                                                        if (e.target.value === 'mpesa') {
                                                            setSelectedCardId(null);
                                                        }
                                                    }}
                                                >
                                                    {/* M-Pesa Option */}
                                                    <div
                                                        style={{
                                                            border: paymentMethod === 'mpesa' ? '2px solid #10B981' : '1px solid #E5E7EB',
                                                            borderRadius: '8px',
                                                            padding: '16px',
                                                            marginBottom: '12px',
                                                            cursor: 'pointer',
                                                            backgroundColor: paymentMethod === 'mpesa' ? '#F0FDF4' : 'white',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onClick={() => {
                                                            setPaymentMethod('mpesa');
                                                            setSelectedCardId(null);
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            value="mpesa"
                                                            control={<Radio sx={{ color: '#10B981', '&.Mui-checked': { color: '#10B981' } }} />}
                                                            label={
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <PhoneAndroid sx={{ color: '#10B981' }} />
                                                                    <span style={{ fontWeight: 500, color: '#374151' }}>M-Pesa</span>
                                                                    <Chip label="Mobile Money" size="small" sx={{ backgroundColor: '#D1FAE5', color: '#065F46', fontSize: '11px' }} />
                                                                </div>
                                                            }
                                                            sx={{ margin: 0, width: '100%' }}
                                                        />

                                                        {/* M-Pesa Phone Number Field */}
                                                        {paymentMethod === 'mpesa' && (
                                                            <div style={{ marginTop: '12px', paddingLeft: '32px' }}>
                                                                <Field
                                                                    as={TextField}
                                                                    name="phone_number"
                                                                    label="M-Pesa Phone Number"
                                                                    placeholder="0712345678"
                                                                    error={
                                                                        formikProps.errors.phone_number &&
                                                                        formikProps.touched.phone_number
                                                                    }
                                                                    helperText={
                                                                        <ErrorMessage className="error" name="phone_number"/>
                                                                    }
                                                                    required
                                                                    variant="outlined"
                                                                    size="small"
                                                                    style={{ width: "100%" }}
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                        style: {color: '#3A5A78'}
                                                                    }}
                                                                />
                                                                <p style={{ fontSize: '12px', color: '#6B7280', marginTop: '8px' }}>
                                                                    You will receive an M-Pesa prompt on this number
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Card Payment Option */}
                                                    <div
                                                        style={{
                                                            border: paymentMethod === 'card' ? '2px solid #3B82F6' : '1px solid #E5E7EB',
                                                            borderRadius: '8px',
                                                            padding: '16px',
                                                            cursor: 'pointer',
                                                            backgroundColor: paymentMethod === 'card' ? '#EFF6FF' : 'white',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onClick={() => setPaymentMethod('card')}
                                                    >
                                                        <FormControlLabel
                                                            value="card"
                                                            control={<Radio sx={{ color: '#3B82F6', '&.Mui-checked': { color: '#3B82F6' } }} />}
                                                            label={
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <CreditCard sx={{ color: '#3B82F6' }} />
                                                                    <span style={{ fontWeight: 500, color: '#374151' }}>Card Payment</span>
                                                                    <Chip label="Visa / Mastercard" size="small" sx={{ backgroundColor: '#DBEAFE', color: '#1E40AF', fontSize: '11px' }} />
                                                                </div>
                                                            }
                                                            sx={{ margin: 0, width: '100%' }}
                                                        />

                                                        {/* Card Options */}
                                                        {paymentMethod === 'card' && (
                                                            <div style={{ marginTop: '12px', paddingLeft: '32px' }}>
                                                                {/* Saved Cards */}
                                                                {cardsLoading ? (
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#6B7280' }}>
                                                                        <CircularProgress size={16} />
                                                                        <span>Loading saved cards...</span>
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        {savedCards.length > 0 && (
                                                                            <div style={{ marginBottom: '16px' }}>
                                                                                <p style={{ fontSize: '13px', fontWeight: 500, color: '#374151', marginBottom: '8px' }}>
                                                                                    Saved Cards
                                                                                </p>
                                                                                {savedCards.map((card) => (
                                                                                    <div
                                                                                        key={card.id}
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'space-between',
                                                                                            padding: '10px 12px',
                                                                                            borderRadius: '6px',
                                                                                            marginBottom: '8px',
                                                                                            border: selectedCardId === card.id ? '2px solid #3B82F6' : '1px solid #E5E7EB',
                                                                                            backgroundColor: selectedCardId === card.id ? '#EFF6FF' : 'white',
                                                                                            cursor: 'pointer',
                                                                                            transition: 'all 0.2s ease'
                                                                                        }}
                                                                                        onClick={() => setSelectedCardId(card.id)}
                                                                                    >
                                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                                            <input
                                                                                                type="radio"
                                                                                                checked={selectedCardId === card.id}
                                                                                                onChange={() => setSelectedCardId(card.id)}
                                                                                                style={{ accentColor: '#3B82F6' }}
                                                                                            />
                                                                                            <div>
                                                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                                                    <span style={{ fontWeight: 500, color: '#374151', textTransform: 'uppercase', fontSize: '13px' }}>
                                                                                                        {card.card_type}
                                                                                                    </span>
                                                                                                    <span style={{ color: '#6B7280', fontSize: '13px' }}>
                                                                                                        •••• {card.last4}
                                                                                                    </span>
                                                                                                    {card.is_default && (
                                                                                                        <Chip
                                                                                                            label="Default"
                                                                                                            size="small"
                                                                                                            sx={{
                                                                                                                backgroundColor: '#DBEAFE',
                                                                                                                color: '#1E40AF',
                                                                                                                fontSize: '10px',
                                                                                                                height: '20px'
                                                                                                            }}
                                                                                                        />
                                                                                                    )}
                                                                                                </div>
                                                                                                <span style={{ fontSize: '12px', color: '#9CA3AF' }}>
                                                                                                    Expires: {card.expiry}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <IconButton
                                                                                            size="small"
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                if (window.confirm('Delete this card?')) {
                                                                                                    handleDeleteCard(card.id);
                                                                                                }
                                                                                            }}
                                                                                            sx={{ color: '#EF4444' }}
                                                                                        >
                                                                                            <DeleteOutline fontSize="small" />
                                                                                        </IconButton>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}

                                                                        {/* New Card Option */}
                                                                        <div
                                                                            style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                padding: '10px 12px',
                                                                                borderRadius: '6px',
                                                                                border: selectedCardId === null ? '2px solid #3B82F6' : '1px solid #E5E7EB',
                                                                                backgroundColor: selectedCardId === null ? '#EFF6FF' : 'white',
                                                                                cursor: 'pointer',
                                                                                transition: 'all 0.2s ease'
                                                                            }}
                                                                            onClick={() => setSelectedCardId(null)}
                                                                        >
                                                                            <input
                                                                                type="radio"
                                                                                checked={selectedCardId === null}
                                                                                onChange={() => setSelectedCardId(null)}
                                                                                style={{ accentColor: '#3B82F6', marginRight: '10px' }}
                                                                            />
                                                                            <CreditCard sx={{ color: '#3B82F6', fontSize: '20px', marginRight: '8px' }} />
                                                                            <span style={{ fontWeight: 500, color: '#374151', fontSize: '13px' }}>
                                                                                Pay with New Card
                                                                            </span>
                                                                        </div>

                                                                        {/* Save Card Checkbox (only for new card) */}
                                                                        {selectedCardId === null && (
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={saveNewCard}
                                                                                        onChange={(e) => setSaveNewCard(e.target.checked)}
                                                                                        sx={{ color: '#3B82F6', '&.Mui-checked': { color: '#3B82F6' } }}
                                                                                    />
                                                                                }
                                                                                label={
                                                                                    <span style={{ fontSize: '13px', color: '#4B5563' }}>
                                                                                        Save card for future payments
                                                                                    </span>
                                                                                }
                                                                                sx={{ marginTop: '8px' }}
                                                                            />
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </RadioGroup>
                                            </FormControl>

                                            {/* Security Notice */}
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                marginTop: '20px',
                                                padding: '12px',
                                                backgroundColor: '#F9FAFB',
                                                borderRadius: '8px',
                                                border: '1px solid #E5E7EB'
                                            }}>
                                                <Lock sx={{ color: '#6B7280', fontSize: '18px' }} />
                                                <span style={{ fontSize: '12px', color: '#6B7280' }}>
                                                    {paymentMethod === 'mpesa'
                                                        ? 'Secured by Safaricom M-Pesa'
                                                        : 'Secured by Paystack - 256-bit SSL encryption'
                                                    }
                                                </span>
                                            </div>

                                            {/* Action Buttons */}
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    marginTop: "24px",
                                                    gap: "12px"
                                                }}
                                            >
                                                <Button
                                                    onClick={handleClose}
                                                    style={{
                                                        color: "#6B7280",
                                                        fontWeight: 500,
                                                        textTransform: 'none'
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                                <LoadingButton
                                                    type="submit"
                                                    size="medium"
                                                    loading={tenantLoading || cardPaymentLoading}
                                                    startIcon={paymentMethod === 'mpesa' ? <PhoneAndroid /> : <CreditCard />}
                                                    style={{
                                                        color: "white",
                                                        backgroundColor: paymentMethod === 'mpesa' ? '#10B981' : '#3B82F6',
                                                        textTransform: 'none',
                                                        padding: '10px 20px',
                                                        borderRadius: '6px'
                                                    }}
                                                    loadingPosition="start"
                                                >
                                                    {paymentMethod === 'mpesa'
                                                        ? 'Pay with M-Pesa'
                                                        : selectedCardId
                                                            ? 'Pay with Saved Card'
                                                            : 'Pay with Card'
                                                    }
                                                </LoadingButton>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                                )}
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>

                    {/* Vacating Notice Dialog */}
                    <Dialog
                        maxWidth="md"
                        open={vacatingNoticeModal}
                        TransitionComponent={Transition}
                        keepMounted
                        aria-describedby="vacating-notice-dialog-description"
                        PaperProps={{
                            style: {
                                borderRadius: '12px',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                            }
                        }}
                    >
                        <DialogTitle
                            style={{
                                color: "#3A5A78",
                                borderBottom: '1px solid #eaeaea',
                                padding: '20px 24px',
                                fontSize: '18px',
                                fontWeight: 600,
                                textAlign: 'center'
                            }}
                        >
                            Vacating Notice
                        </DialogTitle>
                        <DialogContent
                            style={{
                                padding: '24px',
                            }}
                        >
                            <Formik
                                initialValues={initialValues2}
                                validationSchema={dateSchema}
                                onSubmit={sendVacatingNotice}
                            >
                                {(props) => (
                                    <Form noValidate>
                                        {/* Checklist Section */}
                                        <div style={{
                                            backgroundColor: '#F8FAFC',
                                            borderRadius: '8px',
                                            padding: '20px',
                                            marginBottom: '24px',
                                            border: '1px solid #E2E8F0'
                                        }}>
                                            <h4 style={{
                                                margin: '0 0 16px 0',
                                                color: '#3A5A78',
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <Info style={{fontSize: '20px'}}/>
                                                Vacating Requirements Checklist
                                            </h4>

                                            <div style={{
                                                maxHeight: '300px',
                                                overflowY: 'auto',
                                                paddingRight: '8px'
                                            }}>
                                                {getVacatingChecklist().map((item) => (
                                                    <div key={item.id} style={{
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        gap: '12px',
                                                        marginBottom: '16px',
                                                        padding: '12px',
                                                        backgroundColor: 'white',
                                                        borderRadius: '6px',
                                                        border: `1px solid ${
                                                            item.status === 'failed' ? '#FEE2E2' :
                                                                item.status === 'warning' ? '#FEF3C7' :
                                                                    item.status === 'passed' ? '#D1FAE5' : '#E5E7EB'
                                                        }`
                                                    }}>
                                                        {item.status === 'passed' && (
                                                            <CheckCircle style={{
                                                                color: '#10B981',
                                                                fontSize: '20px',
                                                                marginTop: '2px'
                                                            }}/>
                                                        )}
                                                        {item.status === 'failed' && (
                                                            <Cancel style={{
                                                                color: '#EF4444',
                                                                fontSize: '20px',
                                                                marginTop: '2px'
                                                            }}/>
                                                        )}
                                                        {item.status === 'warning' && (
                                                            <Warning style={{
                                                                color: '#F59E0B',
                                                                fontSize: '20px',
                                                                marginTop: '2px'
                                                            }}/>
                                                        )}
                                                        {item.status === 'info' && (
                                                            <Info style={{
                                                                color: '#3B82F6',
                                                                fontSize: '20px',
                                                                marginTop: '2px'
                                                            }}/>
                                                        )}

                                                        <div style={{flex: 1}}>
                                                            <div style={{
                                                                fontWeight: 600,
                                                                fontSize: '14px',
                                                                color: '#374151',
                                                                marginBottom: '4px'
                                                            }}>
                                                                {item.title}
                                                            </div>
                                                            <div style={{
                                                                fontSize: '13px',
                                                                color: '#6B7280',
                                                                marginBottom: item.risk ? '6px' : 0
                                                            }}>
                                                                {item.description}
                                                            </div>
                                                            {item.risk && (
                                                                <div style={{
                                                                    fontSize: '12px',
                                                                    color: item.status === 'failed' ? '#DC2626' : '#D97706',
                                                                    fontWeight: 500,
                                                                    fontStyle: 'italic'
                                                                }}>
                                                                    ⚠️ {item.risk}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "16px",
                                                flexWrap: "wrap"
                                            }}
                                        >
                                            <Field
                                                as={TextField}
                                                name="first_name"
                                                label="First Name"
                                                variant="outlined"
                                                error={
                                                    props.errors.first_name && props.touched.first_name
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="first_name"/>
                                                }
                                                required
                                                disabled={true}
                                                style={{marginTop: "16px", width: "calc(33.33% - 11px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="last_name"
                                                label="Last Name"
                                                error={
                                                    props.errors.last_name && props.touched.last_name
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="last_name"/>
                                                }
                                                required
                                                variant="outlined"
                                                disabled={true}
                                                style={{marginTop: "16px", width: "calc(33.33% - 11px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="national_id"
                                                label="National ID"
                                                type="number"
                                                required
                                                variant="outlined"
                                                disabled={true}
                                                style={{marginTop: "16px", width: "calc(33.33% - 11px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "16px"
                                            }}
                                        >
                                            <Field
                                                as={TextField}
                                                name="phone_number"
                                                label="Phone Number"
                                                error={
                                                    props.errors.phone_number &&
                                                    props.touched.phone_number
                                                }
                                                className={
                                                    props.errors.phone_number &&
                                                    props.touched.phone_number
                                                        ? "input-error"
                                                        : ""
                                                }
                                                helperText={
                                                    <ErrorMessage className="error" name="phone_number"/>
                                                }
                                                required
                                                variant="outlined"
                                                style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                            <Field
                                                as={TextField}
                                                name="unit"
                                                label="House Number"
                                                error={props.errors.unit && props.touched.unit}
                                                helperText={
                                                    <ErrorMessage className="error" name="unit"/>
                                                }
                                                required
                                                disabled={true}
                                                variant="outlined"
                                                style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {color: '#3A5A78'}
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "16px"
                                            }}
                                        >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    disabled={true}
                                                    value={dateToday}
                                                    onChange={() => {
                                                    }}
                                                    label="Date Today"
                                                    inputFormat="MM/DD/YYYY"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            name="date_notice_given"
                                                            error={
                                                                props.errors.date_notice_given &&
                                                                props.touched.date_notice_given
                                                            }
                                                            helperText={
                                                                <ErrorMessage
                                                                    className="error"
                                                                    name="date_notice_given"
                                                                />
                                                            }
                                                            style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                            {...params}
                                                            InputLabelProps={{
                                                                style: {color: '#3A5A78'}
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Date To Vacate"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={dateToVacate}
                                                    onChange={(newValue) => setDateToVacate(newValue)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            name="date_to_vacate_House"
                                                            error={
                                                                props.errors.date_to_vacate_House &&
                                                                props.touched.date_to_vacate_House
                                                            }
                                                            helperText={
                                                                <ErrorMessage
                                                                    className="error"
                                                                    name="date_notice_given"
                                                                />
                                                            }
                                                            style={{marginTop: "16px", width: "calc(50% - 8px)"}}
                                                            {...params}
                                                            InputLabelProps={{
                                                                style: {color: '#3A5A78'}
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </div>

                                        <div
                                            style={{
                                                marginTop: "24px",
                                            }}
                                        >
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '8px',
                                                color: '#3A5A78',
                                                fontWeight: 500
                                            }}>
                                                Reason for Vacating
                                            </label>
                                            <RichTextEditor
                                                richTextValue={editorState}
                                                change={(value) => {
                                                    setEditorState(value);
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                marginTop: "24px",
                                                gap: "12px"
                                            }}
                                        >
                                            <Button
                                                onClick={handleClose}
                                                style={{
                                                    color: "#EF4444",
                                                    fontWeight: 500,
                                                    textTransform: 'none'
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                            <LoadingButton
                                                type="submit"
                                                size="medium"
                                                loading={tenantLoading}
                                                startIcon={<Send/>}
                                                style={{
                                                    color: "white",
                                                    backgroundColor: "#3A5A78",
                                                    textTransform: 'none',
                                                    padding: '8px 16px',
                                                    borderRadius: '6px'
                                                }}
                                                loadingPosition="start"
                                            >
                                                Submit
                                            </LoadingButton>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </DialogContent>
                    </Dialog>
                </>
            )}

            {/* Main Dashboard Cards */}
            <div style={{
                fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif"
            }}>
                {/* Top Row Cards */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '24px',
                    marginBottom: '24px'
                }}>
                    {/* Wallet Balance Card */}
                    <div style={{
                        flex: '1',
                        backgroundColor: '#F0FDF4',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        border: '1px solid #D1FAE5',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px'
                        }}>
                            <h3 style={{
                                margin: 0,
                                color: '#065F46',
                                fontSize: '16px',
                                fontWeight: 600
                            }}>
                                Wallet Balance
                            </h3>
                            <AccountBalanceWallet style={{color: '#059669'}}/>
                        </div>

                        <HtmlTooltip title="Account Balance">
                            <p style={{
                                fontSize: '24px',
                                fontWeight: 700,
                                margin: '0 0 16px 0',
                                color: '#065F46'
                            }}>
                                {getFormattedWalletBalance()}
                            </p>
                        </HtmlTooltip>

                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            padding: '6px 0',
                            color: '#059669',
                            fontWeight: 500,
                            fontSize: '14px'
                        }} onClick={() => {
                            openPaymentModal();
                        }}>
                            <span>Deposit</span>
                            <Payment style={{marginLeft: '8px', fontSize: '18px'}}/>
                        </div>
                    </div>

                    {/* Property Card */}
                    <div style={{
                        flex: '1',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        border: '1px solid #E5E7EB',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px'
                        }}>
                            <h3 style={{
                                margin: 0,
                                color: '#3A5A78',
                                fontSize: '16px',
                                fontWeight: 600
                            }}>
                                Property
                            </h3>
                            <Apartment style={{color: '#3B82F6'}}/>
                        </div>

                        <p style={{
                            fontSize: '24px',
                            fontWeight: 700,
                            margin: '0 0 16px 0',
                            color: '#3A5A78'
                        }}>
                            {tenantDetails.get("property_name")}
                        </p>

                        <div style={{
                            fontSize: '14px',
                            color: '#6B7280'
                        }}>
                            Unit {tenantDetails.get("house_number")}
                        </div>
                    </div>

                    {/* Rent Agreed Card */}
                    <div style={{
                        flex: '1',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        border: '1px solid #E5E7EB',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px'
                        }}>
                            <h3 style={{
                                margin: 0,
                                color: '#3A5A78',
                                fontSize: '16px',
                                fontWeight: 600
                            }}>
                                Rent Agreed
                            </h3>
                        </div>

                        <p style={{
                            fontSize: '24px',
                            fontWeight: 700,
                            margin: '0 0 16px 0',
                            color: '#3A5A78'
                        }}>
                            {tenantDetails.get("rent")?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "KES",
                            })}
                        </p>

                        <div style={{
                            fontSize: '14px',
                            color: '#6B7280'
                        }}>
                            Rent Is Due By 5<sup>th</sup>
                        </div>
                    </div>
                </div>

                {/* Bottom Row Cards */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '24px'
                }}>
                    {/* Pending Bill Card */}
                    {tenantDetails.get("status") !== "COMPLETED" ? (
                        <motion.div
                            animate={{scale: [0.98, 1, 0.98]}}
                            transition={{duration: 3, repeat: Infinity}}
                            style={{
                                flex: '1',
                                backgroundColor: '#FEF2F2',
                                borderRadius: '12px',
                                padding: '24px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                                border: '1px solid #FEE2E2',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#991B1B',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Pending Bill
                                </h3>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <p style={{
                                    fontSize: '24px',
                                    fontWeight: 700,
                                    margin: 0,
                                    color: '#991B1B'
                                }}>
                                    {parseInt(
                                        tenantDetails.get("Wallet")?.toString().replace(",", "") || "0"
                                    ).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "KES",
                                    })}
                                </p>

                                <Button
                                    style={{
                                        background: '#EF4444',
                                        color: 'white',
                                        textTransform: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        fontWeight: 500
                                    }}
                                    onClick={() => {
                                        openPaymentModal();
                                    }}
                                >
                                    Pay Now
                                    <Payment
                                        style={{
                                            marginLeft: '6px',
                                            fontSize: '20px'
                                        }}
                                    />
                                </Button>
                            </div>

                            <div style={{
                                fontSize: '14px',
                                color: '#B91C1C'
                            }}>
                                Pay On Time To Avoid Penalties
                            </div>
                        </motion.div>
                    ) : (
                        <div style={{
                            flex: '1',
                            backgroundColor: '#F0FDF4',
                            borderRadius: '12px',
                            padding: '24px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                            border: '1px solid #D1FAE5',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#065F46',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Pending Bill
                                </h3>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <p style={{
                                    fontSize: '24px',
                                    fontWeight: 700,
                                    margin: 0,
                                    color: '#065F46'
                                }}>
                                    {parseInt(
                                        "0".toString().replace(",", "") || "0"
                                    ).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "KES",
                                    })}
                                </p>

                                <Button
                                    style={{
                                        background: '#10B981',
                                        color: 'white',
                                        textTransform: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        fontWeight: 500
                                    }}
                                    onClick={() => {
                                        openPaymentModal();
                                    }}
                                >
                                    Pay Now
                                    <Payment
                                        style={{
                                            marginLeft: '6px',
                                            fontSize: '20px'
                                        }}
                                    />
                                </Button>
                            </div>

                            <div style={{
                                fontSize: '14px',
                                color: '#059669'
                            }}>
                                All Bills Cleared
                            </div>
                        </div>
                    )}

                    {/* Notice Card - Updated with Recall functionality */}
                    {tenantDetails.get("state") === "NOTICE" ? (
                        <motion.div
                            animate={{scale: [0.98, 1, 0.98]}}
                            transition={{duration: 3, repeat: Infinity}}
                            style={{
                                flex: '1',
                                backgroundColor: '#EFF6FF',
                                borderRadius: '12px',
                                padding: '24px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                                border: '1px solid #DBEAFE',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#1E40AF',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Available Notice
                                </h3>
                                <Assignment style={{color: '#3B82F6'}}/>
                            </div>

                            <p style={{
                                fontSize: '16px',
                                fontWeight: 500,
                                margin: '0 0 16px 0',
                                color: '#1E40AF'
                            }}>
                                You requested to vacate on:{" "}
                                <span style={{fontWeight: 700}}>
                  {new Map(
                      Object.entries(tenantDetails.get("notice") || {})
                  ).get("date_to_vacate_house")}
                </span>
                            </p>

                            <div style={{
                                fontSize: '14px',
                                color: '#3B82F6',
                                marginBottom: '16px'
                            }}>
                                Date notice given:{" "}
                                {new Map(Object.entries(tenantDetails.get("notice") || {})).get(
                                    "date_created"
                                )}
                            </div>

                            <LoadingButton
                                onClick={handleRecallNoticeClick}
                                loading={tenantLoading}
                                startIcon={<Delete/>}
                                style={{
                                    background: '#EF4444',
                                    color: 'white',
                                    textTransform: 'none',
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    fontWeight: 500,
                                    alignSelf: 'flex-start'
                                }}
                                loadingPosition="start"
                            >
                                Recall Notice
                            </LoadingButton>
                        </motion.div>
                    ) : (
                        <div style={{
                            flex: '1',
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '24px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                            border: '1px solid #E5E7EB',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <h3 style={{
                                    margin: 0,
                                    color: '#3A5A78',
                                    fontSize: '16px',
                                    fontWeight: 600
                                }}>
                                    Notice
                                </h3>
                                <Assignment style={{color: '#3B82F6'}}/>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px'
                            }}>
                                <p style={{
                                    fontSize: '16px',
                                    fontWeight: 500,
                                    margin: 0,
                                    color: '#3A5A78'
                                }}>
                                    Vacating Notice
                                </p>

                                <Button
                                    style={{
                                        background: '#3B82F6',
                                        color: 'white',
                                        textTransform: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        fontWeight: 500
                                    }}
                                    onClick={() => {
                                        setVacatingNoticeModal(true);
                                    }}
                                >
                                    Fill Form
                                    <Assignment
                                        style={{
                                            marginLeft: '6px',
                                            fontSize: '20px'
                                        }}
                                    />
                                </Button>
                            </div>

                            <div style={{
                                fontSize: '14px',
                                color: '#6B7280'
                            }}>
                                Ts & Cs Apply
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}